import React from 'react';
import * as Styled from './styles';
import { useSweep } from '../../hooks/useSweep';

const DAY_LABELS = [
    'One',
    'Two',
    'Three',
    'Four',
    'Five',
    'Six',
    'Seven',
    'Eight',
    'Nine',
    'Ten'
];

export const UpcomingRounds = () => {
    const { sweep } = useSweep();

    if (!sweep || !sweep.copyEnabled) {
        return null;
    }

    const copyText = Array.isArray(sweep.copyText) ? sweep.copyText : [];

    // Split text on numbers (with optional currency prefix and commas/decimals)
    // and wrap each numeric match in <Styled.Jackpot>.
    const NUMBER_REGEX = /([£$€]?\d[\d,]*(?:\.\d+)?)/g;
    const NUMBER_TEST = /^[£$€]?\d[\d,]*(?:\.\d+)?$/;
    const renderWithJackpots = text => {
        if (typeof text !== 'string') {
            return text;
        }
        const parts = text.split(NUMBER_REGEX);
        return parts.map((part, i) =>
            NUMBER_TEST.test(part) ? (
                // eslint-disable-next-line react/no-array-index-key
                <Styled.Jackpot key={i}>{part}</Styled.Jackpot>
            ) : (
                part
            )
        );
    };

    return (
        <Styled.Wrapper>
            <Styled.DescriptionWrapper>
                <Styled.Dates>{sweep.copyFestivalName}</Styled.Dates>
                <Styled.Title>{sweep.copyHeader}</Styled.Title>
                <Styled.Blurb>
                    <strong>{sweep.copyDescription}</strong>
                </Styled.Blurb>
            </Styled.DescriptionWrapper>
            <Styled.ScheduleWrapper>
                {copyText.map((text, index) => {
                    const isLast = index === copyText.length - 1;
                    const InfoComponent = isLast
                        ? Styled.DayInfoWithBottomGutter
                        : Styled.DayInfo;
                    const label = DAY_LABELS[index] || `${index + 1}`;

                    return (
                        // eslint-disable-next-line react/no-array-index-key
                        <Styled.DayWrapper key={index}>
                            <Styled.DateWrapper>
                                <Styled.DayNumber>Day</Styled.DayNumber>
                                <Styled.DayNumber>{label}</Styled.DayNumber>
                            </Styled.DateWrapper>
                            <Styled.InfoWrapper>
                                <InfoComponent>
                                    {renderWithJackpots(text)}
                                </InfoComponent>
                            </Styled.InfoWrapper>
                        </Styled.DayWrapper>
                    );
                })}
            </Styled.ScheduleWrapper>
        </Styled.Wrapper>
    );
};

UpcomingRounds.defaultProps = {};

UpcomingRounds.propTypes = {};

export default UpcomingRounds;
